import axios from 'axios';

const apiUrl = process.env['REACT_APP_API_URL'];

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export enum apiEndpoints {
  getProduct = '/get-product',
  addCartItems = '/add-cart-items',
  updateIndividual = '/update-individual',
  getParty = '/get-party',
  scrubAddress = '/scrub-address',
  getTaxCode = '/get-tax-code',
  submitOrder = '/submit-new-connect-order',
  getTaxCodes = '/get-tax-codes',
  deactivateBillingAccount = '/deactivate-billing-account',
  getAgreements = '/get-agreements',
  upsertCartAddons = '/upsert-cart-addons',
  upsertCartPlan = '/upsert-cart-plan',
  getPreviewProducts = '/get-preview-products',
  getClosingOffer = '/get-closing-offer',
  updateMarketingPreferences = '/update-marketing-preferences',
  getCidPhoneMap = '/get-cid-phone-map',
  createIndividual = '/create-individual',
  addBillingAccount = '/add-billing-account',
  getAvailableAppointments = '/get-available-appointments',
  createOrganization = '/create-organization',
  getFeatureFlags = '/get-feature-flags',
  updateOrganization = '/update-organization',
  getEicMessages = '/get-eic-messages',
  updateEic = '/update-eic',
}

export enum MutationKeys {
  getProduct = 'getProduct',
  addProduct = 'addProductToCart',
  updateIndividual = 'updateIndividual',
  scrubAddress = 'scrubAddress',
  scrubMailingAddress = 'scrubMailingAddress',
  getAgreements = 'getAgreements',
  upsertCartAddons = 'upsertCartAddons',
  addBillingAccount = 'addBillingAccount',
  updateEic = 'updateEic',
}

export enum QueryKeys {
  getParty = 'getParty',
  submitOrder = 'submitOrder',
  getAgreements = 'getAgreements',
  getPreviewProducts = 'getPreviewProducts',
  getFeatureFlags = 'getFeatureFlags',
  getTaxCode = 'getTaxCode',
  getEicMessages = 'getEicMessages',
}

export default api;
